// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".triggers[data-v-138dbcee] {\n  -webkit-justify-content: space-between !important;\n      -ms-flex-pack: justify !important;\n          justify-content: space-between !important;\n}\n.triggers .calculation[data-v-138dbcee] {\n    padding: 0 20px !important;\n}\n.triggers .calculation span[data-v-138dbcee] {\n      margin-left: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
